<div class="edit-unit-main">
  <div class="d-flex justify-content-between align-items-center">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="back-navigation hide"
      (click)="closeDialog()"
    />
    <div>
      <p class="building-name text-center">
        <app-with-tooltip [showHelpCursor]="true">{{
          buildingName
        }}</app-with-tooltip>
      </p>
      <p class="modal-title text-center bold-heading mt-2">
        <app-with-tooltip [showHelpCursor]="true">
          {{ this.accessPoint?.accessPointName }}</app-with-tooltip
        >
      </p>
    </div>
    <div class="col-1">
      <img
        src="/assets/svg/ico-cross.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div class="col-8">
      <h1 class="text-center heading1">
        {{ 'EDIT_ACCESS_POINT_DETAILS' | translate }}
      </h1>
    </div>
  </div>

  <div class="">
    <form class="pb-5" [formGroup]="editAccesPointForm">
      <div class="form-group rounded-top form-container">
        <mat-form-field appearance="fill" class="w-100 mb-2">
          <mat-label>{{ 'ACCESS_POINT_ASTERISK' | translate }}</mat-label>
          <input
            matInput
            [placeholder]="'ENTER_ACCESSPOINT_NAME' | translate"
            formControlName="accessPointName"
            oninput="validity.valid||(value='');"
          />
          <mat-error
            *ngIf="
              editAccesPointForm?.controls?.accessPointName?.errors?.whitespace
            "
            >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              editAccesPointForm?.controls?.accessPointName?.errors?.maxlength
            "
          >
            {{
              commonService.stringInterPolation(
                ("MAXIMUM_OF_CHARACTERS" | translate),
                "50"
              )
            }}
          </mat-error>
          <mat-error
            *ngIf="
              editAccesPointForm?.controls?.accessPointName?.errors?.required
            "
            >{{ 'ACCESS_POINT_NAME_IS_REQUIRED' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              editAccesPointForm?.controls?.accessPointName?.errors?.minlength
            "
            >{{ 'YOU_MUST_ENTER_MIN_TWO_CHAR' | translate }}</mat-error
          >
          <mat-error>
            <span
              *ngIf="
                editAccesPointForm?.controls?.accessPointName?.errors
                  ?.requiredSpecialCharForLock
              "
              >{{ 'YOU_MUST_ENTER_A_VALID_ACCESS_POINT_NAME' | translate }}</span
            >
            <span
              *ngIf="
                editAccesPointForm?.controls?.accessPointName?.errors
                  ?.firstCharacterIsNumberNow
              "
              >{{
                'NAME_SHOULD_START_WITH_ALPHABETIC_CHARACTER' | translate
              }}</span
            >
          </mat-error>

          <mat-error
            *ngIf="
              editAccesPointForm?.controls?.accessPointName?.errors
                ?.requiredSpecialCharForLock &&
              !editAccesPointForm?.controls?.accessPointName?.errors
                ?.required &&
              !editAccesPointForm?.controls?.accessPointName?.errors
                ?.whitespace &&
              !editAccesPointForm?.controls?.accessPointName?.errors
                ?.minlength &&
              !editAccesPointForm?.controls?.accessPointName?.errors?.maxlength
            "
            >{{ 'YOU_MUST_ENTER_VALID_AP_NAME' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </form>
    <div class="mt-5 pt-5">
      <div class="row mt-5">
        <button
          class="btn btn-danger px-3 w-100 save-btn"
          type="button"
          tabindex="0"
          [controlDisabled]="[PageName.Unit, CONSTANTS.UPDATE]"
          [disabledCheck]="!editAccesPointForm.valid"
          (click)="
            editAccessPointHandler(
              siteId,
              buildingId,
              floorId,
              accessPoint?.accessPointId,
              editAccesPointForm?.controls.accessPointName.value
            )
          "
        >
          {{ 'SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
